// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/tinymce/skins/lightgray/skin.min.css
// module id = 367
// module chunks = 1